import styles from "./styles.module.scss";
import primaryComponents from "../../../primaryComponents";
import { ArrowUp, CopyIcon } from "../../../../assets/svgIcons";
import { useContext } from "react";
import { ToastContext } from "../../../../hooks/context";
import Images from "../../../../assets/images";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSelector } from "react-redux";

export const StorefrontTemplateUrl = ({ storefrontList = [] }) => {
  const triggerToast = useContext(ToastContext);
  const { business_id } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  return (
    <div className={styles.contentContainer}>
      <span>Select a template you want your customers to visit</span>
      <div className={styles.templateContainer}>
        {storefrontList?.find(
          (item) => item?.template_in_use === "template-2",
        ) && (
          <div className={styles.template}>
            <div className={styles.imgContainer}>
              <img src={Images.template1} alt="" width={250} height={180} />
              <div className={styles.badgeContainer}>
                <div className={styles.badge}>Template 1</div>
              </div>
            </div>
            <div className={styles.btnContainer}>
              <CopyToClipboard
                text={
                  window.location.origin +
                  "/storefront/" +
                  `${
                    storefrontList?.[0]?.slug_url
                      ?.split("/storefront/")?.[1]
                      ?.split("-")?.[0]
                  }`
                }
                onCopy={() => triggerToast("Copied", "success")}
              >
                <primaryComponents.Button classNames="btn btn--primary smallBtn">
                  <span>
                    <CopyIcon />
                  </span>
                  <span className="ml-1">Copy Link</span>
                </primaryComponents.Button>
              </CopyToClipboard>
              <primaryComponents.Button
                classNames="btn btn--outline smallBtn"
                onClick={() =>
                  window.open(
                    window.location.origin +
                      "/storefront/" +
                      `${
                        storefrontList?.[0]?.slug_url
                          ?.split("/storefront/")?.[1]
                          ?.split("-")?.[0]
                      }`,
                    "_blank",
                  )
                }
              >
                <ArrowUp />
                <span className="ml-2">Visit</span>
              </primaryComponents.Button>
            </div>
          </div>
        )}
        {storefrontList?.find(
          (item) => item?.template_in_use === "template-1",
        ) && (
          <div className={styles.template}>
            <div className={styles.imgContainer}>
              <img src={Images.template2} alt="" width={250} height={180} />
              <div className={styles.badgeContainer}>
                <div className={styles.badge}>Template 2</div>
              </div>
            </div>
            <div className={styles.btnContainer}>
              <CopyToClipboard
                text={`${process.env.REACT_APP_LUMI_STOREFRONT_APP_BASE_URL}/glb?bsid=${business_id}`}
                onCopy={() => triggerToast("Copied", "success")}
              >
                <primaryComponents.Button classNames="btn btn--primary smallBtn">
                  <span>
                    <CopyIcon />
                  </span>
                  <span className="ml-1">Copy Link</span>
                </primaryComponents.Button>
              </CopyToClipboard>
              <primaryComponents.Button
                classNames="btn btn--outline smallBtn"
                onClick={() => {
                  window.open(
                    `${process.env.REACT_APP_LUMI_STOREFRONT_APP_BASE_URL}/glb?bsid=${business_id}`,
                    "_blank",
                  );
                }}
              >
                <ArrowUp />
                <span className="ml-2">Visit</span>
              </primaryComponents.Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
